import { LOGIN_SUCCESS, LOGOUT, UPDATE_USER } from './authActions'

const initialState = {
  isAuthenticated: false,
  userData: null
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        userData: action.payload
      }
    
    case UPDATE_USER:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload
        }
      }
    
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        userData: null
      }
    
    default:
      return state
  }
}

export default authReducer